export type BG = '#1A2807' | '#4C6335' | '#ECFAC5' | '#EAE3D1' | '#FDFAF2' | '#852201' | '#010101' | '#FFFFFF'
const colorsMap = {
  '#ECFAC5': '#282829', // Green Onyx + black
  '#1A2807': '#ECFAC5', // Wildwood Green + Green onyx
  '#FDFAF2': '#282829', // White Sand + black
  '#EAE3D1': '#282829', // Sand + black
  '#4C6335': '#FFFFFF', // Moss Green + White
  '#010101': '#FFFFFF', // Black + White
  '#FFFFFF': '#282829', // White + Black
  '#852201': '#FFFFFF', // Burnt Amber + White
} as const satisfies Record<BG, string>

export function getForeground(background?: BG) {
  if (!background || !colorsMap[background]) return '#282829'
  return colorsMap[background]
}
